import Dynamometer from './containers/Dynamometer';
export default Dynamometer;